import React from 'react';

const HeadingOptions = ({ editor }) => {
  return (
    <div className="headingOptions">
      <h3>Heading</h3>
      {/* Options will be added later */}
    </div>
  );
};

export default HeadingOptions;
